import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'

import Input from '~/client/components/AvatarInput'

const AvatarInput = withJsonFormsControlProps(function (props) {
  const { required, data, handleChange, path } = props
  const onChange = React.useCallback(
    value => { handleChange(path, value) },
    [handleChange]
  )
  return <Input {...{
    ...props,
    value: data,
    onChange,
    required,
  }}/>
})
export default AvatarInput
